import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import { Form, Input, Select, Row, Col, Divider, DatePicker } from "antd";
import moment from "moment";

const { Option } = Select;

// Stored/submitted as "YYYY-MM-DD" (unchanged for the backend); displayed as DD-MM-YYYY.
const toMomentDate = (value) =>
    value ? moment(value, ["YYYY-MM-DD", "DD-MM-YYYY"]) : null;
const fromPickerDate = (date) => (date ? date.format("YYYY-MM-DD") : "");

const Step4Documents = () => {
    const { control } = useFormContext();

    return (
        <div style={{ background: "#fff", padding: 25, borderRadius: 8 }}>
            <Form layout="vertical">

                {/* ---------------- COI CHECK PROCESS ---------------- */}
                <h5 style={{ marginBottom: 25, fontWeight: 600 }}>COI Check Process</h5>

                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item label="Has the local COI been Done">
                            <Controller
                                name="localCOI"
                                control={control}
                                render={({ field }) => <Input  {...field} />}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Has the global check been done">
                            <Controller
                                name="globalCheck"
                                control={control}
                                render={({ field }) => <Input  {...field} />}

                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item label="Has AML and worldCheck been done">
                            <Controller
                                name="amlWorldCheck"
                                control={control}
                                render={({ field }) => <Input  {...field} />}

                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Has the corporate tree been requested">
                            <Controller
                                name="corporateTreeRequest"
                                control={control}
                                render={({ field }) => <Input  {...field} />}

                            />
                        </Form.Item>
                    </Col>
                </Row>


                {/* ---------------- CONCLUSION SECTION ---------------- */}
                <Divider style={{ margin: "30px 0" }} />

                <h3 style={{ marginBottom: 25 }}>
                    Conclusion: I have performed the firm’s required Conflict of Interest Checks’ procedures, as indicated above and based on these procedures,
                    I approve the onboarding of this client
                </h3>

                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item label="Relationship / Liaison Manager">
                            <Controller
                                name="liaisonManagerApproval"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Signature">
                            <Controller
                                name="signatureApproval"
                                control={control}
                                render={({ field }) => <Input placeholder="Enter" {...field} />}
                            />
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item label="Date">
                            <Controller
                                name="approvalDate"
                                control={control}
                                render={({ field }) => (
                                    <DatePicker
                                        className="w-100"
                                        format="DD-MM-YYYY"
                                        value={toMomentDate(field.value)}
                                        onChange={(date) => field.onChange(fromPickerDate(date))}
                                    />
                                )}
                            />
                        </Form.Item>
                    </Col>
                </Row>


                {/* ---------------- FINAL ACCEPTANCE ---------------- */}
                <Divider style={{ margin: "30px 0" }} />
                <Row gutter={24}>
                    <Col span={12}>
                        <Form.Item label="Client Acceptance Form Completed">
                            <Controller
                                name="acceptanceCompleted"
                                control={control}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        placeholder="Select"
                                        allowClear
                                        style={{ width: "100%" }}
                                    >
                                        <Option value="yes">Yes</Option>
                                        <Option value="no">No</Option>
                                    </Select>
                                )}
                            />
                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item label="Client Onboarded">
                            <Controller
                                name="clientOnboarded"
                                control={control}
                                render={({ field }) => (
                                    <Select
                                        {...field}
                                        placeholder="Select"
                                        allowClear
                                        style={{ width: "100%" }}
                                    >
                                        <Option value="Yes">Yes</Option>
                                        <Option value="No">No</Option>
                                    </Select>
                                )}
                            />
                        </Form.Item>
                    </Col>
                </Row>

            </Form>
        </div>
    );
};

export default Step4Documents;